<template>
    <div class="hsl-sliders">
        <slider :value="hue" 
				class="hue stagger-in-up" 
				:max="360"
                @input="updateField($event, 'hue')"/>
        <slider :value="saturation" 
				class="saturation stagger-in-up"
                :style="saturationBackgroundStyle()"
                @input="updateField($event, 'saturation')"/>
        <slider :value="lightness" 
				class="lightness stagger-in-up"
                :style="lightnessBackgroundStyle()"
                @input="updateField($event, 'lightness')"/>
    </div>
</template>

<script>
    import Color        from "../../../../../Lib/Color";
    import withinBounds from "../../../../../Lib/helpers/withinBounds";
    import BaseColorInput from "./BaseColorInput";
    import Slider         from "./Slider";

    export default {
        name: "HslSliders",
        components: {Slider},
        extends: BaseColorInput,

        computed: {
            hsl() {
                return this.draft.hsl();
            },
            hue() {
                return Math.round(this.hsl.hue);
            },
            saturation() {
                return Math.round(this.hsl.saturation);
            },
            lightness() {
                return Math.round(this.hsl.lightness);
            },
        },

        data() {
            return {
                colorType: 'hsl',
            }
        },

        methods: {

            getValue() {
                return this.hsl;
            },

            getSanitizedColor(value) {
                value = this.sanitize(value);
                return Color.fromHSL(value);
            },

            sanitize(value) {
                value.hue        = withinBounds(value.hue, 0, 360);
                value.saturation = withinBounds(value.saturation);
                value.lightness  = withinBounds(value.lightness);

                return value;
            },

            lightnessBackgroundStyle() {
                return 'background: linear-gradient(to right, #000000 0%, ' + this.getHueOutput() + ' 50%, #ffffff 100%)';
            },
            saturationBackgroundStyle() {
                return 'background: linear-gradient(to right, ' + this.getDesaturatedOutput() + ' 0%, ' + this.getHueOutput() + ' 100%)';
            },
            getHueOutput() {
                return Color.fromHSL({hue: this.hue, saturation: 100, lightness: 50}).hex().value;
            },
            getDesaturatedOutput() {
                return Color.fromHSL({hue: this.hue, saturation: 0, lightness: 50}).hex().value;
            }
        },
    }
</script>
